import { combineReducers } from "redux";
import notificationReducer from "./ducks/notification";
import userReducer, { SIGN_OUT } from "./ducks/user";
import employerReducer from "./ducks/employer";

const reducers = combineReducers({
  notificationReducer,
  userReducer,
  employerReducer,
});

const rootReducer = (state, action) => {
  if (action.type === SIGN_OUT) {
    state = undefined;
  }

  return reducers(state, action);
};

export default rootReducer;
